<script setup lang="ts">
import { Button } from 'primevue';
import { IconSettings } from '@iconify-prerendered/vue-ic';
import { ref } from 'vue';
import SettingsDialog from '@/settings/SettingsDialog.vue';

const settingsDialogVisible = ref(false);

function showSettings() {
  settingsDialogVisible.value = true;
}

</script>

<template>
  <Button severity="secondary" @click="showSettings">
  <template #icon>
    <IconSettings style="width: 1.25em; height: 1.25em"></IconSettings>
  </template>
  </Button>

  <SettingsDialog v-model:visible="settingsDialogVisible"></SettingsDialog>
</template>
